import { useMemo } from 'react'

import type { TimeDimension } from '@cubejs-client/core'
import { QueryOptions, useCubeReportPageFiltersContext } from 'cube'
import { SiteConciergeSearchQuery } from 'cube/queries/SiteConciergeSearch.query'
import moment from 'moment'

import {
  CubeQueryBuilder,
  resultSetAsTableData,
  useCubeQuery,
} from '@driftt/dds.reports'

import useTimePeriod from 'hooks/useTimePeriod'

export const useSiteConciergeSearchCardsMertics = (options?: QueryOptions) => {
  const timePeriod = useTimePeriod()
  const { isPreviousTimePeriod = false } = { ...options }
  const { pageFilters = [] } = useCubeReportPageFiltersContext()

  const dateRange: [string, string] = [
    moment(
      isPreviousTimePeriod ? timePeriod.prevStart : timePeriod.startDate
    ).format('YYYY-MM-DD'),
    moment(
      isPreviousTimePeriod ? timePeriod.prevEnd : timePeriod.endDate
    ).format('YYYY-MM-DD'),
  ]

  const timeDimensions: TimeDimension[] = [
    {
      dimension: 'DriftSiteConcierge.eventSentAt',
      dateRange,
    },
  ]

  const queryName = isPreviousTimePeriod
    ? 'SiteConciergeSearchQuery-previous'
    : 'SiteConciergeSearchQuery'
  SiteConciergeSearchQuery.name = queryName
  SiteConciergeSearchQuery.queryName = queryName

  const { data, isLoading, isError } = useCubeQuery({
    query: new CubeQueryBuilder({
      query: SiteConciergeSearchQuery,
    })
      .withTimeDimensions(timeDimensions)
      .withFilters(pageFilters)
      .build(),
  })

  const cardData = useMemo(() => {
    return resultSetAsTableData(data)
  }, [data])

  const metrics = cardData.map(({ DriftSiteConcierge }) => {
    return {
      searchButtonClicks: Number(DriftSiteConcierge.searchButtonClicks) || 0,
      searchesPerformed: Number(DriftSiteConcierge.searchesPerformed) || 0,
      sourceClickThroughs: Number(DriftSiteConcierge.sourceClickThroughs) || 0,
      totalButtonImpressions: Number(DriftSiteConcierge.countLoads) || 0,
    }
  })[0]

  return { metrics, isLoading, isError }
}
